import { memo, useId } from "react"
import { Tooltip } from "react-tooltip"

interface ErrorIconWithTooltipProps {
    error: string
    id: string
}

interface ErrorFieldWrapperProps {
    error?: string
    children: React.ReactNode
    htmlFor?: string
}

const ErrorIconWithTooltip = memo(({ error, id }: ErrorIconWithTooltipProps) => {
    return (
        <div className="relative inline-block ml-2">
            <div
                data-tooltip-id={id}
                className="w-4 h-4 bg-red-500 text-white rounded-full text-xs flex items-center justify-center cursor-help"
            >
                i
            </div>
            <Tooltip
                id={id}
                content={error}
                className="!bg-red-600 !text-white !text-sm !px-3 !py-2 !rounded-lg !z-50"
                noArrow={false}
                place="top"
            />
        </div>
    )
})

export const ErrorFieldWrapper = memo(({ error, children }: ErrorFieldWrapperProps) => {
    const tooltipId = useId()

    return (
        <div className="relative h-full">
            {children}
            {error && <ErrorIconWithTooltip error={error} id={tooltipId} />}
        </div>
    )
})